<template>
  <Section
    v-bind="$attrs"
    title="Properties"
    :shouldShowSearch="shouldShowSearch"
    :toolbarActions="toolbarActions"
    :isPrimary="isPrimary"
    @onClicked="(val) => $emit(val)"
    icon="list_alt"
    :isLoading="isLoading"
  >
    <v-data-table
      :headers="headers"
      :items="propertyList"
      item-key="id"
      class="elevation-1"
      :rows-per-page-items="[15, 25, 50, 100]"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ props.item.key }}
        </td>
        <td class="text-xs-left">
          {{ props.item.value }}
        </td>
        <td class="text-xs-right">
          <ControlButton
            text="Delete"
            icon="delete_forever"
            iconColor="error"
            :disabled="isLoading"
            @onClicked="
              $emit('onRemovePropertyClicked', {
                propertyId: props.item.id,
                key: props.item.key,
                value: props.item.value,
              })
            "
          />
          <ControlButton
            text="Edit"
            icon="edit"
            iconColor="warning"
            :disabled="isLoading"
            @onClicked="
              $emit('onEditPropertyClicked', { propertyToEdit: props.item })
            "
          />
        </td>
      </template>
    </v-data-table>
  </Section>
</template>

<script>
import mixinAssetHelper from '../../../../common/mixins/mixinAssetHelper'

import Section from '../../../../common/components/layouts/Section'
import ControlButton from '../../../../common/components/controls/ControlButton'

export default {
  inheritAttrs: false,
  components: {
    Section,
    ControlButton,
  },
  mixins: [mixinAssetHelper],
  props: {
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    shouldShowSearch: {
      type: Boolean,
    },
    isPrimary: {
      type: Boolean,
      default: true,
    },
    propertyList: {
      type: Array,
      required: true,
    },
    propertyKeyList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    headers: [
      { text: 'Model', value: 'key', sortable: false },
      { text: 'Value', value: 'value', sortable: false },
      { text: '', sortable: false },
    ],
  }),
  computed: {},
  methods: {},
}
</script>
